import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";
import { VLYT } from "@/constants/testIds/vlyt";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_vlyt-launch/artifacts/3733o5po_02ebb175-0a71-49d5-93b5-137f92b27689.jpeg";

export default function Footer() {
  return (
    <footer
      className="relative bg-[color:var(--vlyt-surface-1)] border-t border-[color:var(--vlyt-border)] mt-24"
      data-testid={VLYT.footer.root}
    >
      <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-16 grid gap-12 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <div className="flex items-center gap-3">
            <img src={LOGO_URL} alt="Vlyt" className="h-11 w-11 rounded-lg object-cover" />
            <span className="font-display text-[20px]">V<span className="text-lime">L</span>YT</span>
          </div>
          <p className="mt-5 max-w-sm text-[color:var(--vlyt-muted)] text-[15px]">
            The intra-community mobility platform for Covenant University. Built for certainty in motion.
          </p>
          <div className="mt-5 flex items-center gap-3 text-[color:var(--vlyt-muted)] text-[13px] font-mono">
            <MapPin size={14} className="text-lime" /> Port Harcourt · Rivers · Nigeria
          </div>
        </div>

        <div>
          <div className="text-eyebrow mb-4">Product</div>
          <ul className="space-y-3">
            <li><Link to="/" className="hover:text-lime">Home</Link></li>
            <li><Link to="/app" className="hover:text-lime">Get the app</Link></li>
            <li><Link to="/support/riders" className="hover:text-lime">For riders</Link></li>
            <li><Link to="/support/drivers" className="hover:text-lime">For drivers</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-eyebrow mb-4">Company</div>
          <ul className="space-y-3">
            <li><Link to="/about" className="hover:text-lime">About</Link></li>
            <li><Link to="/about/miesindou" className="hover:text-lime">Founder</Link></li>
            <li><Link to="/support/contact" className="hover:text-lime">Contact</Link></li>
          </ul>
        </div>

        <div>
          <div className="text-eyebrow mb-4">Legal</div>
          <ul className="space-y-3">
            <li><Link to="/privacy" className="hover:text-lime">Privacy Policy</Link></li>
            <li><Link to="/terms" className="hover:text-lime">Terms of Service</Link></li>
          </ul>
          <div className="mt-6 flex items-center gap-3">
            <a href="mailto:hello@govlyt.com" aria-label="Email" className="h-10 w-10 rounded-full border border-[color:var(--vlyt-border)] flex items-center justify-center hover:border-lime hover:text-lime">
              <Mail size={16} />
            </a>
            <a href="https://instagram.com/senalagha" target="_blank" rel="noreferrer" aria-label="Instagram" className="h-10 w-10 rounded-full border border-[color:var(--vlyt-border)] flex items-center justify-center hover:border-lime hover:text-lime">
              <Instagram size={16} />
            </a>
          </div>
        </div>
      </div>

      <div className="border-t border-[color:var(--vlyt-border)]">
        <div className="mx-auto max-w-[1440px] px-5 md:px-10 py-6 flex flex-col md:flex-row items-start md:items-center justify-between gap-3 text-[13px] text-[color:var(--vlyt-muted)] font-mono">
          <span data-testid={VLYT.footer.year}>© {new Date().getFullYear()} Vlyt Technologies Ltd. All rights reserved.</span>
          <span>Certainty in Motion · v1.0</span>
        </div>
      </div>
    </footer>
  );
}
